export default __webpack_public_path__ + "static/media/4-2_image19@2x.deb746fe.png";